<template>
  <el-main class="My-Account">
    <div class="title-style">
      <el-divider class="left-divider"></el-divider>
      <div class="center-text">{{ $t('account.name1') }}</div>
      <el-divider class="right-divider"></el-divider>
    </div>
    <div class="email-style">
      <div><el-input v-model="email" :placeholder="$t('retrievePassword.name3')"></el-input></div>
      <div class="code">
        <el-input :placeholder="$t('retrievePassword.name4')" v-model="code">
          <template slot="append">
            <el-button type="primary" :loading="codeLoading" @click="getCode">{{ $t('retrievePassword.name5') }}</el-button>
          </template>
        </el-input>
      </div>
    </div>
    <el-button type="success" class="submit-email" :loading="loading" @click="submitEmail">{{ $t('account.name4') }}</el-button>

    <div class="title-style">
      <el-divider class="left-divider"></el-divider>
      <div class="center-text1">{{ $t('account.name2') }}</div>
      <el-divider class="right-divider"></el-divider>
    </div>

    <div class="textarea"><el-input type="textarea" :rows="3" :placeholder="$t('public.name5')" v-model="remark"> </el-input></div>
    <el-button type="success" class="submit-email" :loading="loading1" @click="submitRemark">{{ $t('account.name4') }}</el-button>
    <div class="title-style">
      <el-divider class="left-divider"></el-divider>
      <div class="center-text1">{{ $t('account.name3') }}</div>
      <el-divider class="right-divider"></el-divider>
    </div>
    <el-select
      v-model="timeZoneId"
      filterable
      class="timezone-select"
      :placeholder="$t('account.name3')"
    >
      <el-option
        v-for="item in timeZoneOptions"
        :key="item.id"
        :label="item.label"
        :value="item.id"
      />
    </el-select>
    <el-button type="success" class="submit-email" :loading="loading2" @click="submitTimeZone">{{ $t('account.name4') }}</el-button>
  </el-main>
</template>
<script>
import { emailSend, updateEmail, updateRemake, updateTimeZone } from '@/api/user.js'
import { TIME_ZONE_OPTIONS, normalizeTimeZoneId, ensureTimeZoneOption } from '@/constants/timeZones'
import { defaultTimeZoneId } from '@/config/flavor'
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['userinfo'])
  },
  data() {
    return {
      email: '',
      code: '',
      remark: '',
      timeZoneId: defaultTimeZoneId,
      timeZoneOptions: TIME_ZONE_OPTIONS,
      codeLoading: false,
      loading: false,
      loading1: false,
      loading2: false
    }
  },
  created() {},
  mounted() {
    const tz = this.userinfo.timeZoneId || this.userinfo.timeZone
    this.timeZoneId = normalizeTimeZoneId(tz)
    this.timeZoneOptions = ensureTimeZoneOption(TIME_ZONE_OPTIONS, this.timeZoneId)
  },
  methods: {
    getCode() {
      if (this.email) {
        const reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
        if (!reg.test(this.email)) {
          this.$message({ message: this.$t('public.name27'), type: 'warning' })
          return
        }
        this.codeLoading = true
        const params = {
          email: this.email,
          type: '1'
        }
        emailSend(params).then(res => {
          this.codeLoading = false
          if (res.code === 200) {
            this.$message({
              message: this.$t('public.name17'),
              type: 'success'
            })
          }
        })
      }
    },
    submitEmail() {
      if (this.code && this.email) {
        this.loading = true
        const params = {
          email: this.email,
          code: this.code
        }
        updateEmail(params).then(res => {
          this.loading = false
          if (res.code === 200) {
            this.$message({
              message: this.$t('public.name18'),
              type: 'success'
            })
          }
        })
      }
    },
    submitRemark() {
      if (this.remark) {
        this.loading1 = true
        const params = {
          remark: this.remark
        }
        updateRemake(params).then(res => {
          this.loading1 = false
          if (res.code === 200) {
            this.$message({
              message: this.$t('public.name18'),
              type: 'success'
            })
          }
        })
      }
    },
    submitTimeZone() {
      if (this.timeZoneId) {
        this.loading2 = true
        const params = {
          timeZoneId: this.timeZoneId
        }
        updateTimeZone(params).then(res => {
          this.loading2 = false
          if (res.code === 200) {
            this.$store.commit('user/updateAlltime', this.timeZoneId)
            this.$store.dispatch('user/getInfo').then(() => {}).catch(() => {})
            this.$bus.$emit('accountTimeZoneChanged', this.timeZoneId)
            this.$message({
              message: this.$t('public.name18'),
              type: 'success'
            })
          }
        })
      }
    }
  }
}
</script>
<style lang="scss">
.el-input-group__append {
  background-color: #0f73e6;
  color: #fff;
  border: 1px solid #0f73e6;
}
.timezone-select {
  width: 360px;
}
</style>
<style lang="scss" scoped>
.My-Account {
  display: flex;
  flex-direction: column;

  .title-style {
    display: flex;
    flex-direction: row;
    align-items: center;
    .left-divider {
      width: 20%;
    }
    .center-text {
      width: 100px;
      text-align: center;
    }
    .center-text1 {
      width: 140px;
      text-align: center;
    }
    .right-divider {
      width: 75%;
    }
  }
  .email-style {
    display: flex;
    flex-direction: row;
    .code {
      margin-left: 15px;
    }
  }

  .submit-email {
    margin-top: 20px;
    max-width: 150px;
  }
  .textarea {
    width: 70%;
  }
}
</style>
